// Dependencies
import React, { createClass, PropTypes } from 'react';
import { Paper } from 'material-ui';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';;

const ConnectionsTagsTypeAhead = createClass({

  propTypes: {
    addOrRemoveTag: PropTypes.func,
    input: PropTypes.string,
    tags: PropTypes.array,
    open: PropTypes.bool,
  },

  getInitialState() {
    return {
      typeAheadDropDownOpen: false,
    };
  },

  addTag(tagName) {
    this.props.addOrRemoveTag(tagName, 'add');
  },

  toggleTypeAheadDropDown() {
    this.setState({ typeAheadDropDownOpen: !this.state.typeAheadDropDownOpen });
  },

  componentClickAway() {
    if (this.state.typeAheadDropDownOpen) this.toggleTypeAheadDropDown();
  },

  render() {
    const { input, tags } = this.props;
    if (!this.props.open) return false;
    const filteredTags = input ?
      tags.filter(option => option.tag.toLowerCase().search(new RegExp(input, 'g')) > -1) :
      undefined;
    const tagsToMap = filteredTags || tags;
    const allTags = tagsToMap.map((tag, index) => {
      return (
        <div className="type-ahead-option-container" key={index} onClick={this.addTag.bind(this, tag.tag)}>
          <div className="type-ahead-option">{tag.tag}</div>
        </div>
      );
    });

    return (
      <ClickAwayListener onClickAway={this.componentClickAway}>
        <Paper zDepth={1}>
          {allTags}
        </Paper>
      </ClickAwayListener>
    );
  },
});

export default ConnectionsTagsTypeAhead;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tags-modal/connections-tags-typeahead/typeahead-dropdown.jsx